/*
 * View-scope helpers used by the dashboard's selectors and gate logic.
 *
 * The role-editor surface (ALL_PERMISSIONS, PERM_DEPS, RoleEditPage, etc.)
 * was retired in Phase 15 — staff and role management now lives in Home.
 * Only the "what does this perm set unlock?" predicates remain, and they
 * mirror VIEW_ALL_CLIENTS_IMPLIED / VIEW_ASSIGNED_CLIENTS_IMPLIED in
 * `apps/pma-server/src/access.js`. Keep the two sides in sync.
 */

const VIEW_ALL_CLIENTS_IMPLIED = new Set<string>([
    'view_billing', 'edit_billing', 'submit_claims',
    'edit_scheduling', 'delete_sessions',
    'view_payroll',
    'export_reports',
    'manage_settings', 'view_audit_log',
]);

const VIEW_ASSIGNED_CLIENTS_IMPLIED = new Set<string>([
    'view_scheduling', 'evv_checkin',
    'view_notes', 'write_notes', 'finalize_notes',
    'data_collection',
    'view_treatment_plans', 'edit_treatment_plans',
    'view_supervision', 'log_supervision',
    'view_eligibility', 'run_eligibility',
    'view_reports',
    'view_portal_assigned', 'view_portal_all',
]);

export function grantsViewAllClients(perms: ReadonlySet<string>): boolean {
    if (perms.has('view_all_clients')) return true;
    for (const p of perms) if (VIEW_ALL_CLIENTS_IMPLIED.has(p)) return true;
    return false;
}

export function grantsAssignedClients(perms: ReadonlySet<string>): boolean {
    if (grantsViewAllClients(perms)) return true;
    if (perms.has('view_assigned_clients')) return true;
    for (const p of perms) if (VIEW_ASSIGNED_CLIENTS_IMPLIED.has(p)) return true;
    return false;
}
